import React from "react";
import classes from "./SinglePage.module.css";

const SinglePage = ({ category }) => {
  return (
    <div className={classes.menu}>
      <header>
        <img src={category.image} alt={category.items[0].name} />
        <h1>{category.name}</h1>
      </header>

      <div className={classes["menu-list"]}>
        {category.items.map((item) => (
          <div key={item.sub_category} className={classes["menu-category"]}>
            <h1>{item.sub_category}</h1>
            <div className={classes.container}>
              {item.items.map((item) => (
                <div key={item.name} className={classes["menu-item"]}>
                  {item.description && (
                    <React.Fragment>
                      <h4>
                        {item.name} - {item.price}₺
                      </h4>
                      <p>{item.description}</p>
                    </React.Fragment>
                  )}
                  {!item.description && (
                    <React.Fragment>
                      <p>
                        {item.name} - {item.price}₺
                      </p>
                    </React.Fragment>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SinglePage;
